module.exports = __webpack_public_path__ + "static/media/wave-grc-3.71be7da0.svg";